import Commander from "./Commander";
import {numberFormat} from "../framework/src/helpers";
import {calcReal} from "../framework/src/wallet/walletOperations";

export default class WinCounter {
    counterDecimalPlaces

    constructor (commander) {
        this.commander = commander;
        this.layer = this.commander.layers.counter;
        this.counterDecimalPlaces = this.commander.wallet.getDecimalPlaces()

        this.tween = {
            scale: 0.4,
            alpha: 1,
            number: 0
        }
    }

    init() {
        this.layer.name = 'counter';

        this.normalBg = Commander.getSprite('background_win.png', 640, 360);
        this.normalBg.visible = false;
        this.layer.addChild(this.normalBg);

        this.text = new PIXI.BitmapText( '', {
            fontName: "font_win-export",
            fontSize: 70,
            tint: 0xFFFFFF,
            align: 'center',
            letterSpacing: 0,
            maxWidth: 1280
        });
        this.text.anchor.set(.5, .5);
        this.text.visible = false;
        this.layer.addChild(this.text);
    }

    setDecimalPlaces(win) {
        let creditWin = numberFormat(
            this.commander.wallet.moneyToCreditWithDecimals(win),
            this.commander.wallet.getDecimalPlaces(),
            '.',
            ' '
        )
        this.counterDecimalPlaces = creditWin.split(".")[1].length
        this.commander.wallet.setWinDecimalPlaces(win)
    }

    normal(time, win, callback = () => {}) {
        let oldWin = this.commander.wallet.getWin();
        this.text.position.set(640, 360);
        this.text.visible = this.normalBg.visible = true;
        this.setDecimalPlaces(win)
        this.resetTween();
        createjs.Tween.get(this.tween)
            .to({scale: 1.4, alpha: 1, number: win}, time)
            .call(() => {
                this.end(win, time, true).then(() => {
                    this.resetTween();
                    callback();
                });
            })
            .addEventListener('change', () => {
                if (this.commander.skipAnim) {
                    this.tween.number = win;
                    this.tween.scale = 1.4;
                    this.end(win, time, true).then(() => {
                        callback();
                    });
                }
                this.commander.setWin(oldWin+this.tween.number);
                this.update(true);
            });
    }

    resetTween() {
        this.tween = {
            scale: 0.4,
            alpha: 1,
            number: 0
        }
    }

    bigWin(time, win, callback = () => {}) {
        let oldWin = this.commander.wallet.getWin();
        this.text.position.set(640, 410);
        this.text.visible = true;
        this.resetTween();
        this.setDecimalPlaces(win)
        this.tween.scale = 1;
        createjs.Tween.get(this.tween)
            .to({scale: 1.1, alpha: 1, number: win}, time)
            .call(() => {
                this.commander.audio.playTrack("win_Fade_Out");
                this.end(win, time).then(() => {
                    callback();
                });
            })
            .addEventListener('change', () => {
                this.update();
                this.commander.setWin(oldWin+this.tween.number);
            });
    }

    freespin(time, win, callback = () => {}) {
        this.text.position.set(640, 410);
        this.text.visible = true;
        this.resetTween();
        this.tween.scale = 1;
        createjs.Tween.get(this.tween)
            .to({scale: 1.1, alpha: 1, number: win}, time)
            .call(() => {
                this.commander.audio.stopTrack("win_Counter_Loop");
                this.end(win, time).then(callback);
            })
            .addEventListener('change', () => {
                this.update();
            });
    }

    end(win, time,  normal = false) {
        Commander.removeTween(this.tween);
        this.text.text = numberFormat(
            this.commander.wallet.moneyToCreditWithDecimals(win),
            this.counterDecimalPlaces,
            '.',
            ' '
        )
        return new Promise(res => {
            this.endSounds(time, normal);
            createjs.Tween.get(this.tween)
                .wait(1000)
                .call(() => {
                    this.commander.audio.fadeOutTrack("bwin_Coins_Loop", 1000);
                })
                .to({scale: 6, alpha: 0}, 150)
                .call(() => {
                    Commander.removeTween(this.tween);
                    if (normal) {
                        this.normalBg.visible = false;
                    }
                    res();
                })
                .addEventListener('change', () => {
                    this.update(normal);
                });
        })
    }

    endSounds(time, normal) {
        if (time === 25000) {
            this.commander.audio.stopTrack("bwin_Bed_UltraWin_Loop");
            this.commander.audio.playTrack("bwin_Bed_UltraWin_Stop");
        }
        if (time === 6000 && !normal) {
            this.commander.audio.stopTrack("win_Bed_Loop");
            this.commander.audio.playTrack("win_Bed_Stop");

        }
        if (normal) {
            this.commander.audio.playTrack("win_Bed_Stop");
        }
        this.commander.audio.stopTrack("win_Bed_Loop");
        this.commander.audio.playTrack("win_Bed_Stop");
        this.commander.audio.stopTrack("win_Counter_Loop");
        this.commander.audio.playTrack("win_Counter_Stop");
    }

    update(normal = false) {

        let win = this.tween.number;

        if (normal) {
            this.normalBg.scale.set(this.tween.scale, this.tween.scale);
            this.normalBg.alpha = this.tween.alpha;
        }
        this.text.scale.set(this.tween.scale, this.tween.scale);
        this.text.alpha = this.tween.alpha;
        this.text.text = numberFormat(
            this.commander.wallet.moneyToCreditWithDecimals(win),
            this.counterDecimalPlaces,
            '.',
            ' '
        )
    }
}